var map = {
	"./index1.vue": [
		36242,
		36242
	],
	"./index2.vue": [
		10012,
		10012
	],
	"./index3.vue": [
		42381,
		42381
	],
	"./index4.vue": [
		622,
		622
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94810;
module.exports = webpackAsyncContext;